import { RemoveScroll } from "react-remove-scroll";
import ReactDom from "react-dom";
import { useTranslation } from "react-i18next";

const StatusModal = ({ open, handleClose, message }) => {
    const { t } = useTranslation(0);
    if (!open) return null;

    return ReactDom.createPortal(
        <div className='fixed top-0 left-0 right-0 h-screen bg-black/40 overflow-clip'>
            <RemoveScroll className='flex justify-center h-full flex-col p-10 bg-transparent'>
                <div
                    className='h-full w-full z-10 absolute bg-transparent'
                    onClick={handleClose}
                ></div>
                <div className='bg-white w-full z-50 max-w-[550px] mx-auto gap-3 overflow-clip flex flex-col rounded-md'>
                    <div className={`w-full py-1.5 ${message?.success === false ? "bg-red-500" : "bg-MetallicBlue"}`}>
                        <p className={`text-lg font-bold text-center ${message?.statusCode === "REJECTED" ? "text-red-600" : message?.statusCode === "PROCESSED" ? "text-nidgreen" : "text-nidyellow"}`}>
                            {message?.success === false ? (
                                <div className='text-white rounded-md'>
                                    <p>Error: {message?.error || "An error occurred."}</p>
                                </div>
                            ) : 
                                message?.statusCode
                            }
                        </p>
                    </div>

                    <div className='flex flex-col items-center justify-end text-center gap-3 text-black pb-4 px-5'>
                        <p>{message?.statusComment}</p>
                        {message?.success && message?.updatedTime && (
                            <p>Date: {message.updatedTime}</p>
                        )}

                        {
                            <button
                                className='px-5 py-1 text-white rounded-md bg-gray-700'
                                type='button'
                                onClick={handleClose}
                            >
                                Close
                            </button>
                        }
                    </div>
                </div>
            </RemoveScroll>
        </div>,
        document.getElementById("portal")
    );
};

export default StatusModal;
